import {
    GETUSERACTIVITYLOG_SUCCESS,
    GETUSERACTIVITYLOG_FAILED,
    RESET_GETUSERACTIVITYLOG,
    LOADING_GETUSERACTIVITYLOG,
    NETWORK_GETUSERACTIVITYLOG,
} from "../types";

const initialState = {
    isLoading: false,
    failed: false,
    success: false,
    invalidRequest: false,
    notFound: false,
    data: {},
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETUSERACTIVITYLOG:
            return {
                ...state,
                isLoading: true,
                failed: false,
                success: false,
                invalidRequest: false,
                notFound: false,
                networkError: "",
            };

        case GETUSERACTIVITYLOG_SUCCESS:

            return {
                ...state,
                isLoading: false,
                failed: false,
                success: true,
                invalidRequest: false,
                notFound: false,
                data: action.payload,
                networkError: "",
            };

        case GETUSERACTIVITYLOG_FAILED:
            return {
                ...state,
                isLoading: false,
                failed: true,
                success: false,
                invalidRequest: false,
                notFound: false,
                data: action.payload,
                networkError: "",
            };

        case NETWORK_GETUSERACTIVITYLOG:
            return {
                ...state,
                isLoading: false,
                failed: false,
                success: false,
                invalidRequest: false,
                notFound: false,
                data: action.payload,
                networkError: "OOPS.... Something went wrong !",
            };

        case RESET_GETUSERACTIVITYLOG:
            return (state = initialState);

        default:
            return state;
    }
};
